module.exports = __webpack_public_path__ + "static/code-ff998881e4dad2089fd369de298551dc.jpg";